// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__YdBAO","insta":"footer_insta__0SQgw","lastpart":"footer_lastpart__5S6zk"};